import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Card,
  CardTitle,
  ContentMaxWidth,
  Muted,
  PageHeading,
  PageSubheading,
  Pill,
  Row,
  Stack,
} from '../../layout/styledComponents'

const sections = [
  { to: '/patient-home/shop/dues', icon: '💳', name: 'Pay outstanding', urgent: true },
  { to: '/patient-home/shop/packs', icon: '🎁', name: 'Session packs' },
  { to: '/patient-home/shop/subscription', icon: '⭐', name: 'Subscription' },
]

export default function ShopIndexPage() {
  const navigate = useNavigate()
  return (
    <ContentMaxWidth>
      <Stack $gap="24px">
        <div>
          <Pill>Shop</Pill>
          <PageHeading style={{ marginTop: 12 }}>Shop &amp; payments</PageHeading>
          <PageSubheading>Pay what&apos;s due, buy session packs, manage your subscription.</PageSubheading>
        </div>
        <Stack $gap="12px">
          {sections.map((s) => (
            <Card
              key={s.to}
              as="button"
              onClick={() => navigate(s.to)}
              style={{ textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit' }}
            >
              <Row $between>
                <Row $gap="14px">
                  <span style={{ fontSize: 24 }}>{s.icon}</span>
                  <CardTitle style={{ margin: 0 }}>{s.name}</CardTitle>
                </Row>
                {s.urgent ? (
                  <Pill $tone="urgent">Pay now</Pill>
                ) : (
                  <span aria-hidden style={{ color: '#6B7280', fontSize: 18 }}>›</span>
                )}
              </Row>
              <Muted style={{ marginTop: 8 }}>Tap to open.</Muted>
            </Card>
          ))}
        </Stack>
      </Stack>
    </ContentMaxWidth>
  )
}
